// extracted by mini-css-extract-plugin
export default {"newDealsContainer":"LandingPage_newDealsContainer__fPyRB"};